import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

import { MAS_ROLE } from '@core/models/mas-history';
import { AuthService } from '@core/services/auth';
import { MAS_API_URL } from '@core/services/mas-history';

/**
 * Matches the message history only where this environment publishes its API, and only for a token carrying the role;
 * anyone else lands on the dashboard. A signed-out visitor matches, so the auth guard can send them to sign in and
 * bring them back to the link.
 */
export const masGuard: CanMatchFn = async () => {
  const router = inject(Router);
  const auth = inject(AuthService);
  const dashboard = router.createUrlTree(['/dashboard']);

  if (inject(MAS_API_URL) === null) {
    return dashboard;
  }
  await auth.awaitReady();
  if (!auth.isAuthenticated()) {
    return true;
  }
  return auth.roles().includes(MAS_ROLE) ? true : dashboard;
};
